import { useEffect } from "react";
import { useRedirect } from "react-admin";
import { DASHBOARD_CONSUMO } from "@/config/resources";

export const DashboardConsumoList = () => {
  const redirect = useRedirect();

  useEffect(() => {
    redirect(`/${DASHBOARD_CONSUMO}`);
  }, [redirect]);

  return null;
};


